import { render, staticRenderFns } from "./ResetPasswordSuccess.vue?vue&type=template&id=6d07a600&scoped=true&"
import script from "./ResetPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordSuccess.vue?vue&type=style&index=0&id=6d07a600&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d07a600",
  null
  
)

export default component.exports